<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增"
				fontSize="14px" @btnclick="adduser">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')"
				title="修改" fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1"
				@btnclick="updateclick">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除"
				fontSize="14px" :useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="del">
			</Commonbtn>
			<!-- <Commonbtn v-if="qx.enabled" backgroundColor="#FFF" :src="require('@/assets/icon/qy.png')" title="启用" fontSize="14px" @btnclick="qy">
      </Commonbtn> -->
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" @handleSelectionChange="handleSelectionChange" ref="dataManageRef"
				colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total" :pageSize="pageSize"></Pagination>
			</div>
		</div>
		<DialogFrom style="scollo" width="1000px" title="新增资料" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrs" ref="Manageadd" @selectAll="selectAll" @removeTag="removeTag"
						@InforSelectChange="InforSelectChange" @remoteMethod="remoteMethod"></FromComm>
				</div>
				<div class="choseBtn">
					<Commonbtn btnType='btn' width="64px" height="32px" title="选择" fontSize="14px"
						backgroundColor="#E71D43" color="#FFF" @btnclick="chose"></Commonbtn>
				</div>
				<div style="display: inline-block;vertical-align: top;position: relative;left: -39px;">
					<CommonUploadEnclosure title="" :typeUpload="1" @getFile="DataManageAddUpload"
						:UploadObj="fileData"></CommonUploadEnclosure>
				</div>
				<!-- <CommUploadAdditional width="460px" backgroundColor="#FAFBFC" :fileData="filesInPutsArr" :srcleft="require('@/assets/channel/icon-FJ.png')" :srcright="require('@/assets/channel/del.png')"></CommUploadAdditional> -->
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="修改资料" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<div style="display: inline-block;">
					<FromComm :FromArr="FromArrs" ref="Manageupdate" @selectAll="selectAll" @removeTag="removeTag"
						@InforSelectChange="InforSelectChange" @remoteMethod="remoteMethod"></FromComm>
				</div>
				<div class="choseBtn">
					<Commonbtn btnType='btn' width="64px" height="32px" title="选择" fontSize="14px"
						backgroundColor="#E71D43" color="#FFF" @btnclick="chose"></Commonbtn>
				</div>
				<div style="display: inline-block;vertical-align: top;position: relative;left: -38px;">
					<CommonUploadEnclosure title="" :typeUpload="1" @getFile="DataManageAddUpload"
						:UploadObj="fileData"></CommonUploadEnclosure>
				</div>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该用户吗？</span>
		</Dialog>
		<DialogFrom width="800px" title="选择发送的对象" :dialogVisible="dialogVisibleObject" @cancel="cancelObject"
			@dialogOK="dialogOKObject">
			<div class="choiceObject">
				<div class="leftTitle">
					<div>
						选择角色/产线
					</div>
					<div class="leftTable">
						<Commontable @onRowClick555="onRowClickLeftTable" ref="choiceObjectTableleftTop"
							@handleSelectionChange="handleSelectionChangeleftTop" width="1000px" colnum=555
							:tableData="tableDataInvClass" :headerData="headerDataInvClass" height="100%">
						</Commontable>
					</div>
					<div class="leftTable">
						<Commontable @onRowClick555="onRowClickLeftTable" width="1000px"
							ref="choiceObjectTableleftBottom" @handleSelectionChange="handleSelectionChangeleftBottom"
							colnum=555 :tableData="tableDataRole" :headerData="headerDataRole" height="100%">
						</Commontable>
					</div>
				</div>
				<div class="rightTitles">
					<div>
						选择用户
					</div>
					<div class="rightSearch">
						<SearchComm placeholder="请输入用户名称" @searchClick="searchClick" :width="205"></SearchComm>
					</div>
					<div class="rightBtn">
						<Commonbtn btnType='btn' width="100px" height="32px" :title="choseAllTitle" fontSize="14px"
							backgroundColor="#E71D43" color="#FFF" @btnclick="ChoseAll"></Commonbtn>
					</div>
					<div class="leftTable">
						<Commontable @onRowClick555="onRowClickLeftTable" ref="choiceObjectTableRight"
							@handleSelectionChange="handleSelectionChangeRight" width="1000px" colnum=555
							:widthselection="90" :tableData="tableDataUser" :headerData="headerDataUser" height="100%">
						</Commontable>
					</div>
					<div class="paginationChose">
						<Pagination layout="total, prev, pager, next, jumper"
							@handleCurrentChange="handleCurrentChangechoiceObject"
							@handleSizeChange="handleSizeChangechoiceObject" :total="totalchoiceObject"></Pagination>
					</div>
				</div>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Dialog from '../../../../components/dialog.vue'
	import CommonUploadEnclosure from '../../../../components/common-upload-Enclosure.vue'
	import CommUploadAdditional from '../../../../components/comm-upload-additional.vue'
	import FromArr from '../fromData/FromArr'
	import fromdataedit from '../fromData/edit'
	import SearchComm from '../../../../components/comm-from-search.vue'
	import {
		HelperGetUserNameAndRole
	} from '@/api/home'
	import {
		DataDownloadListApi,
		DataDownloadAdd,
		DataDownloadEdit,
		DataDownloadDelete,
		DataDownloadInfo,
		DataDownloadUpLoadAttachment,
		GetHelperDataDownloadType,
		DataDownloadClassListForNode,
	} from '@/api/channel'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonUploadEnclosure,
			CommUploadAdditional,
			FromComm,
			SearchComm
		},
		props: {

		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibleqy: false,
				dialogVisibleObject: false,
				choseAllFlag: false,
				total: 0,
				pageSize: 10,
				pageindex: 1,
				totalchoiceObject: 0,
				pageSizeObject: 10,
				pageIndexObject: 1,
				username: '',
				name: '',
				ptype: '',
				type: '',
				zname: '',
				parentId: '',
				infoID: '',
				ChoseObjectName: '',
				choseAllTitle: '全部选择',
				rowboo: false,
				FromArrs: [],
				fromdataedit: [],
				fileData: null,
				resdetailsList: {},
				qus: [],
				tableData: [],
				invClassList: [],
				RoleList: [],
				UserList: [],
				selectData: [],
				Objects: [],
				tableDataInvClass: [],
				headerDataInvClass: [{
					prop: 'ObjectName',
					label: '产线',
					columnwidth: 180
				}, ],
				tableDataUser: [],
				headerDataUser: [{
						prop: 'ObjectID',
						label: '用户名',
						columnwidth: 180
					},
					{
						prop: 'ObjectName',
						label: '用户名称',
						columnwidth: 180
					},
				],
				tableDataRole: [],
				headerDataRole: [{
					prop: 'ObjectName',
					label: '角色',
					columnwidth: 180
				}, ],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false
				},
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 80
					},
					{
						prop: 'Attachment',
						par: 'Extension',
						label: '文件',
						columnwidth: 80
					},
					{
						prop: 'FileTypeName',
						label: '资料分类',
						columnwidth: 200
					},
					{
						prop: 'Title',
						par: 'FileName',
						label: '标题',
						columnwidth: 450
					},
					{
						prop: 'CreatorName',
						label: '发布对象'
					},
					{
						prop: 'CreateTime',
						label: '发布时间'
					},
				]
			}
		},
		created() {
			this.DataDownloadListApi()
			this.getHelperDataDownloadType();
		},
		mounted() {
			this.FromArrs = JSON.parse(JSON.stringify(FromArr))
			// this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			handleSelectionChange(val) {
				this.selectData = val
			},
			getSingleSelectedRow(actionName) {
				if (this.selectData.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}！`)
					return null
				}
				return this.selectData[0]
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus.map((item, index) => {
					if (item.NodeID == 74) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 75) {
								this.qus = items.Nodes
							}
						})
					}
				})
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					}
				})

			},
			// 上传附件
			async DataDownloadUpLoadAttachment(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await DataDownloadUpLoadAttachment(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.fileData = res.data
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						//    this.dialogVisiblesdrjg = true
						// this.tableDatadrjg = res.data
						// this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			// 下载文件列表
			async DataDownloadListApi(e = '', t = '') {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await DataDownloadListApi({
					IsForEdit: 1,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
					FileType: e,
					Title: t
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			DataManageAddUpload(file) {
				console.log(file, 'e');

				this.DataDownloadUpLoadAttachment(file)
			},
			// 新增
			async DataDownloadAdd() {
				// console.log(this.fromdataadd[0].modelvalue, 'sss');
				let invClass = []
				let Role = []
				let User = []
				let objectInPuts = []
				//拼接格式 ==> 刘俊峰[ad1003][账号]","归创[101][产品线]",
				if (this.invClassList) {
					this.invClassList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						invClass.push(invObj)
					})
				}
				if (this.RoleList) {
					this.RoleList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						Role.push(invObj)
					})
				}
				if (this.UserList) {
					this.UserList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						User.push(invObj)
					})
				}
				console.log(this.invClassList, '---invClassList');
				console.log(this.RoleList, '---RoleList');
				console.log(this.UserList, '---UserList');
				objectInPuts = (invClass.concat(Role)).concat(User)
				console.log(objectInPuts, '---objectInPuts');
				let {
					code,
					message,
					data
				} = await DataDownloadAdd({
					title: this.FromArrs[0].modelvalue,
					attachment: this.fileData,
					objectInPuts: objectInPuts,
					FileType: this.FromArrs[2].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo = false
					this.$refs.dataManageRef.$refs.fileTableSelect.setCurrentRow('');
					this.DataDownloadListApi()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}

			},
			//详情
			async DataDownloadInfo() {

				let {
					code,
					message,
					data
				} = await DataDownloadInfo({
					infoID: this.infoID
				})

				if (code == 0) {
					this.fileData = data.Attachment
					this.Objects = data.Objects
					let arr = []
					data.Objects.filter(item => {
						arr.push(item.ObjectName)
					})
					this.FromArrs[0].modelvalue = data.Title
					this.FromArrs[1].modelvalue = arr.join('、')
					this.FromArrs[2].modelvalue = data.FileType
					this.$forceUpdate();
				}

			},
			// 修改
			async DataDownloadEdit() {
				let invClass = []
				let Role = []
				let User = []
				let objectInPuts = []
				//拼接格式 ==> 刘俊峰[ad1003][账号]","归创[101][产品线]",
				if (this.invClassList) {
					this.invClassList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						invClass.push(invObj)
					})
				}
				if (this.RoleList) {
					this.RoleList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						Role.push(invObj)
					})
				}
				if (this.UserList) {
					this.UserList.map(item => {
						let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
						User.push(invObj)
					})
				}
				objectInPuts = (invClass.concat(Role)).concat(User)
				let ObjectsAll = []
				this.Objects.map(item => {
					let invObj = `${item.ObjectName}[${item.ObjectID}][${item.ObjectType}]`
					ObjectsAll.push(invObj)
				})
				let {
					code,
					message,
					data
				} = await DataDownloadEdit({
					infoID: this.infoID,
					title: this.FromArrs[0].modelvalue,
					attachment: this.fileData,
					objectInPuts: this.choseAllFlag == true ? [] : (objectInPuts != '' ? objectInPuts :
						ObjectsAll),
					FileType: this.FromArrs[2].modelvalue,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesedit = false
					this.DataDownloadListApi()
					this.rowboo = false
					this.$refs.dataManageRef.$refs.fileTableSelect.setCurrentRow('');
				} else {
					this.$message.warning(message)
				}
			},
			// 删除
			async DataDownloadDelete() {
				let {
					code,
					message,
					data
				} = await DataDownloadDelete({
					infoID: this.infoID
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesedit = false
					this.DataDownloadListApi()
				} else {
					this.$message.warning(message)
				}
			},
			//获取文件类型
			async getHelperDataDownloadType() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassListForNode({})
				if (code == 0) {
					this.FromArrs[2].options = data;
					this.$forceUpdate();
				} else {
					this.$message.warning(message)
				}
			},
			onRowClick(val) {
				this.rowboo = true
				this.infoID = val.InfoID
			},
			adduser() {
				this.dialogVisibles = true
				this.getHelperDataDownloadType();
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.DataDownloadAdd()
				this.dialogVisibles = false
			},
			updateclick() {
				const row = this.getSingleSelectedRow('修改')
				if (!row) return
				this.infoID = row.InfoID
				this.rowboo = true
				this.dialogVisiblesedit = true
				this.DataDownloadInfo()
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.DataDownloadEdit()
			},
			del() {
				const row = this.getSingleSelectedRow('删除')
				if (!row) return
				this.infoID = row.InfoID
				this.rowboo = true
				this.dialogVisibledel = true
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.DataDownloadDelete()
				this.dialogVisibledel = false
			},
			handleCurrentChange(PageIndex) {
				this.pageindex = PageIndex
				this.DataDownloadListApi()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.DataDownloadListApi()
			},
			// // 全选
			selectAll() {
				if (this.FromArrs[1].modelvalue.length < this.FromArrs[1].options.length) {
					this.FromArrs[1].modelvalue = []
					this.FromArrs[1].options.map((item) => {
						this.FromArrs[1].modelvalue.push(item.value)
					})
					this.FromArrs[1].modelvalue.unshift('全选')
				} else {
					this.FromArrs[1].modelvalue = []
				}
			},
			// 多选的Change事件
			InforSelectChange(e) {
				if (!e.FromArr[1].modelvalue.includes('全选') && e.FromArr[1].modelvalue.length === this.FromArrs[1].options
					.length) {
					this.FromArrs[1].modelvalue.unshift('全选')
				} else if (e.FromArr[1].modelvalue.includes('全选') && (e.FromArr[1].modelvalue.length - 1) < this.FromArrs[
						1].options.length) {
					this.FromArrs[1].modelvalue = this.FromArrs[1].modelvalue.filter((item) => {
						return item !== '全选'
					})
				}
			},
			// 删除全选选项全部删除
			removeTag(val) {
				if (val === '全选') {
					this.FromArrs[1].modelvalue = []
				}
			},
			remoteMethod(val) {
				if (val.parsign == 'PublishremoteMethod') {
					this.HelperGetUserNameAndRole(val.qurey)
				}
				console.log(val, 'qurey');
			},
			chose() {
				this.dialogVisibleObject = true
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				setTimeout(() => {
					this.HelperGetUserNameAndRole()
					this.HelperGetUserNameAndRoleInvClass()
					this.HelperGetUserNameAndRoleUserName()
					loading.close()
				}, 100)
			},
			cancelObject() {
				this.dialogVisibleObject = false
			},
			dialogOKObject() {
				console.log(this.UserList, 'UserList');
				let name = []
				let arr = (this.UserList.concat(this.invClassList)).concat(this.RoleList)
				arr.map(item => {
					name.push(item.ObjectName)
				})
				this.FromArrs[1].modelvalue = name.join('、')
				this.dialogVisibleObject = false
			},
			// 发送用户接口-用户名
			async HelperGetUserNameAndRoleUserName() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await HelperGetUserNameAndRole({
					name: this.ChoseObjectName,
					ObjectType: 'UserName',
					pageSize: this.pageSizeObject,
					pageIndex: this.pageIndexObject
				})
				if (code == 0) {
					this.tableDataUser = []
					// this.UserList = []
					this.totalchoiceObject = data.Count
					this.tableDataUser = data.data
					if (this.Objects) {
						this.Objects.map(item => {
							if (item.ObjectType == "账号") {
								this.UserList.push(item)
							}
						})
					}
					let userArr = []
					this.$nextTick(() => {
						this.UserList.forEach((item, index) => {
							this.tableDataUser.forEach((items, indexs) => {
								if (item.ObjectName == items.ObjectName) {
									console.log(item);
									userArr.push(item)
									this.$refs.choiceObjectTableRight.$refs.fileTable555
										.toggleRowSelection(items, true);
								}
							})
						})
					})
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 发送用户接口-角色
			async HelperGetUserNameAndRole() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await HelperGetUserNameAndRole({
					ObjectType: 'Roles',
				})
				if (code == 0) {
					this.tableDataRole = []
					// this.RoleList = []
					this.tableDataRole = data.data
					if (this.Objects) {
						this.Objects.map(item => {
							if (item.ObjectType == "角色") {
								this.RoleList.push(item)
							}
						})
					}
					console.log(this.RoleList, 'this.RoleList');
					let userArr = []
					this.$nextTick(() => {
						this.RoleList.forEach((item, index) => {
							this.tableDataRole.forEach((items, indexs) => {
								if (item.ObjectName == items.ObjectName) {
									console.log(item);
									userArr.push(item)
									this.$refs.choiceObjectTableleftBottom.$refs.fileTable555
										.toggleRowSelection(items, true);
								}
							})
						})
					})
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 发送用户接口-产线
			async HelperGetUserNameAndRoleInvClass() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await HelperGetUserNameAndRole({
					ObjectType: 'InvClass',
				})
				if (code == 0) {
					this.dialogVisibleObject = true
					this.tableDataInvClass = []
					// this.invClassList = []
					this.tableDataInvClass = data.data
					console.log(this.Objects, 'Objects');
					if (this.Objects) {
						this.Objects.map(item => {
							if (item.ObjectType == "产品线") {
								this.invClassList.push(item)
							}
						})
						let userArr = []
						this.$nextTick(() => {
							this.invClassList.forEach((item, index) => {
								this.tableDataInvClass.forEach((items, indexs) => {
									if (item.ObjectName == items.ObjectName) {
										userArr.push(item)
										this.$refs.choiceObjectTableleftTop.$refs.fileTable555
											.toggleRowSelection(items, true);
									}
								})
							})
						})
					}

				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			onRowClickLeftTable(val) {

			},
			searchClick(val) {
				this.ChoseObjectName = val
				this.HelperGetUserNameAndRoleUserName()
			},
			handleSelectionChangeleftTop(val) {
				this.invClassList = val
			},
			handleSelectionChangeleftBottom(val) {
				console.log(val);
				this.RoleList = val
			},
			handleSelectionChangeRight(val) {
				this.UserList = val
			},
			handleCurrentChangechoiceObject(pageIndex) {
				this.pageIndexObject = pageIndex
				this.HelperGetUserNameAndRoleUserName()
			},
			handleSizeChangechoiceObject(pageSize) {
				this.pageSizeObject = pageSize
				this.HelperGetUserNameAndRoleUserName()
			},
			ChoseAll() {
				this.choseAllFlag = !this.choseAllFlag
				if (this.choseAllFlag) {
					this.choseAllTitle = '取消选择'
					this.$nextTick(() => {
						for (let i = 0; i < this.tableDataInvClass.length; i++) {
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.toggleRowSelection(this
								.tableDataInvClass[i], true);
						}
						for (let i = 0; i < this.tableDataRole.length; i++) {
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.toggleRowSelection(this
								.tableDataRole[i], true);
						}
						for (let i = 0; i < this.tableDataUser.length; i++) {
							this.$refs.choiceObjectTableRight.$refs.fileTable555.toggleRowSelection(this
								.tableDataUser[i], true);
						}
					})
				} else {
					this.choseAllTitle = '全部选择'
					this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
					this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
					this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();

				}

			},
		},
		watch: {
			dialogVisibles: {
				handler(newVal, oldVal) {
					if (newVal == true) {
						this.fileData = null,
							this.FromArrs.map((item, index) => {
								item.modelvalue = ''
							})
						this.Objects = []
						try {
							this.choseAllFlag = false
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
						} catch (error) {

						}
					}
				}
			},
			dialogVisiblesedit: {
				handler(newVal, oldVal) {
					if (newVal == true) {
						this.fileData = null,
							this.FromArrs.map((item, index) => {
								item.modelvalue = ''
							})
						this.choseAllFlag = false

					}
				}
			},
			dialogVisibleObject: {
				handler(newValue, oldValue) {
					if (newValue == true) {
						try {
							this.choseAllFlag = false
							this.$refs.choiceObjectTableleftTop.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableleftBottom.$refs.fileTable555.clearSelection();
							this.$refs.choiceObjectTableRight.$refs.fileTable555.clearSelection();
						} catch (error) {

						}

					}
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 20px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// flex-wrap: wrap;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.choseBtn {
		position: absolute;
		top: 105px;
		left: 900px;
	}

	.choiceObject {
		width: 946px;
		height: 100%;
		// border: 1px solid red;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		font-weight: normal;
		color: #333333;
		line-height: 20px;

		.leftTitle {
			width: 230px;
			font-size: 14px;

			overflow: hidden;

			.leftTable {
				margin-left: -10px;
				margin-top: 20px;
			}
		}

		.paginationChose {
			position: relative;
			right: 60px;
			top: 50px;
		}

		.rightTitles {
			width: 710px;
			font-size: 14px;

			.rightSearch {
				position: relative;
				top: -45px;
				left: -350px;
			}

			.rightBtn {
				position: absolute;
				top: 50px;
				left: 650px;
			}

			.leftTable {
				margin-left: -10px;
				margin-top: 20px;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
